import Request from './request';
import { API_PATH } from '../../config/config';

export default class Service {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new Service();
	}

	getServices() {
		return Request.instance().get('/services');
	}

	healthCheck(url) {
		if(!url) {
			return Promise.reject(new Error('Unavailable'));
		}
		return Request.instance().get(API_PATH + url);
	}
}